import { render, staticRenderFns } from "./EditGrupoUsuario.vue?vue&type=template&id=da86376a"
import script from "./EditGrupoUsuario.vue?vue&type=script&lang=js"
export * from "./EditGrupoUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports